module.exports = __webpack_public_path__ + "img/dis-wufawancheng.aee5a992.svg";